import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const installHomeMonte: BlogMetaData = {
  title: '「おうちモンテ」入門 - 自己成長サイクルを作るモンテッソーリ教育の始め方',
  description:
    'おうちモンテの始め方をモンテ歴20年以上の講師が解説！自分の興味を伸ばす、自己成長ができる環境をおうちで作りましょう。',
  thumbnailUrl: '/img/blog-install-home-monte.webp',
  filePath: buildBlogFilePath('install-home-monte'),
  category: BLOG_CATEGORY.INTRODUCTION,
};
